/**
 * Remove style elements from documents
 */
export const removeStyleElements = ( elements: HTMLStyleElement[] ): void => {
	elements.forEach( ( element ) => {
		element.remove();
	} );
};
